<template>
  <div class="container" style="padding: 10px; min-width: 800px">
      <carDeatil :detailsData="detailsData" :isDisabledEdit="true"></carDeatil>
  </div>
</template>
<script setup>
import carDeatil from "@/components/carDeatil/index2.vue";
import { onMounted, ref } from "vue";
import { getFindZhufengOfferDetail } from "@/api/AuctionManage/index.js";
const dialogVisible = ref(false);

const title = ref("车辆详情");

const detailsData = ref({});

const loading = ref(false);


onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  console.log(urlParams.get('id')); // 输出 URL 参数的值
  handleGetFindZhufengOfferDetail(urlParams.get('id'));
});


/**
 * 获取汽车详情
 */
const handleGetFindZhufengOfferDetail = async (id) => {
  loading.value = true;
  let res = await getFindZhufengOfferDetail({ id });
  if (res.success) {
    detailsData.value = res.entity;
  }
  loading.value = false;
};

</script>
<style lang="scss" scoped>
</style>
